"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const floating_vue_1 = require("floating-vue");
const lucide_vue_next_1 = require("lucide-vue-next");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const EBecropController_1 = __importDefault(require("../Types/EBecropController"));
const FiltersPanel_vue_1 = __importDefault(require("./FiltersPanel.vue"));
const trans_1 = require("@common/tsutils/trans");
let SearchPanel = class SearchPanel extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.filteredZone = '';
        this.notDrawingMessage = '';
        this.predictiveStates = [];
        this.errorSearchState = false;
    }
    updateFilteredZone(newZone) {
        this.filteredZone = newZone;
        this.eBecropController.isFieldListExpanded = false;
        this.eBecropController.isFilterPanelExpanded = false;
    }
    updateFilteredZoneSearchBar() {
        if (this.eBecropController.filteredState.state !== this.filteredZone || this.eBecropController.currentField) {
            this.filteredZone = '';
        }
    }
    updateErrorSearch() {
        if (this.filteredZone.length < 1) {
            this.predictiveStates = [];
        }
    }
    getPredictiveStates() {
        if (this.filteredZone.length > 0) {
            this.predictiveStates = this.eBecropController.getStatesContainingText(this.filteredZone);
            if (this.predictiveStates.length < 1)
                this.errorSearchState = true;
            else
                this.errorSearchState = false;
        }
        else {
            this.predictiveStates = [];
        }
        ;
        if (this.eBecropController.filteredState.state === this.filteredZone)
            this.predictiveStates = [];
    }
    emptySearchBox(event) {
        if (event.shiftKey && event.key === 'D') {
            this.filteredZone = '';
        }
    }
    notDrawing() {
        if (this.eBecropController.resolution === 'low') {
            this.notDrawingMessage = (0, trans_1.trans)('e_becrop.control_panel.not_painting_low');
        }
        setTimeout(() => {
            this.notDrawingMessage = '';
        }, 3000);
    }
    get loadingZone() {
        return false;
    }
    async filterZone() {
        this.eBecropController.updateFilteredZone(this.filteredZone);
        if (this.eBecropController.isCreateDrawingZone) {
            this.eBecropController.updateCreatingZone();
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: new EBecropController_1.default() })
], SearchPanel.prototype, "eBecropController", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('eBecropController.filteredState'),
    (0, vue_property_decorator_1.Watch)('eBecropController.currentField')
], SearchPanel.prototype, "updateFilteredZoneSearchBar", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('filteredZone')
], SearchPanel.prototype, "updateErrorSearch", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('filteredZone')
], SearchPanel.prototype, "getPredictiveStates", null);
SearchPanel = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Button: bmk_ui_framework_1.Button,
            Dropdown: floating_vue_1.Dropdown,
            Settings2Icon: bmk_ui_framework_1.Settings2Icon,
            PencilIcon: bmk_ui_framework_1.PencilIcon,
            Search: lucide_vue_next_1.Search,
            InputField: bmk_ui_framework_1.InputField,
            PinIcon: bmk_ui_framework_1.PinIcon,
            FiltersPanel: FiltersPanel_vue_1.default,
            XRoundedIcon: bmk_ui_framework_1.XRoundedIcon,
            X: lucide_vue_next_1.X,
            List: bmk_ui_framework_1.List,
            ListItem: bmk_ui_framework_1.ListItem,
        },
    })
], SearchPanel);
exports.default = SearchPanel;
